import PublishWizardCollectionModal from './PublishWizardCollectionModal.container'

export default PublishWizardCollectionModal
